export const PHONE = "0152 53940340";
export const PHONE_TEL = "+4915253940340";
export const EMAIL = "info@voltcore-elektro.de";
export const WEBSITE = "voltcore-elektro.de";
export const OWNER = "Bajenaru Andreea Raluca";
export const STREET = "Heuchlingerstr. 10";
export const CITY = "91224 Pommelsbrunn";
export const LOCATION = "Heuchlingerstr. 10, 91224 Pommelsbrunn";
export const MAP_QUERY = "Heuchlingerstr. 10, 91224 Pommelsbrunn, Deutschland";
export const HERO_IMG = "/hero-worker.webp";

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Referenzen", href: "#referenzen" },
  { label: "Kontakt", href: "#kontakt" },
];

export const HERO_FEATURES = [
  { icon: "BadgeCheck", l1: "Millimetergenaue", l2: "Kernbohrungen" },
  { icon: "Atom", l1: "Staubarmes", l2: "Arbeiten" },
  { icon: "Clock", l1: "Zuverlässig", l2: "& Pünktlich" },
  { icon: "UsersRound", l1: "Erfahrenes", l2: "Fachteam" },
];

export const SERVICES = [
  { icon: "Drill", img: "/work-kernbohrung.webp", title: "Kernbohrungen", desc: "Präzise Kernbohrungen in Beton, Mauerwerk und Stahlbeton." },
  { icon: "Ruler", img: "/work-schlitz.webp", title: "Schlitzarbeiten", desc: "Saubere Schlitze für Elektroleitungen nach Norm und Maß." },
  { icon: "Cable", img: "/work-leerrohre.webp", title: "Kabelzug", desc: "Fachgerechter Einzug von Kabeln und Leitungen." },
  { icon: "CircleDashed", img: "/work-dosen.webp", title: "Dosenbohrungen", desc: "Bohrungen für Schalter- und Abzweigdosen – sauber und exakt." },
  { icon: "Route", img: "/work-stair.webp", title: "Kabelkanäle", desc: "Montage von Kabelkanälen für eine sichere und ordentliche Installation." },
  { icon: "GitBranch", img: "/work-leerrohre.webp", title: "Leerrohre", desc: "Verlegung von Leerrohren für eine zukunftssichere Elektroinstallation." },
];

export const REASONS = [
  { title: "Jahrelange Erfahrung", sub: "in der Elektrovorbereitung" },
  { title: "Saubere & staubarme Arbeitsweise", sub: "für ein perfektes Ergebnis" },
  { title: "Hochwertige Ausrüstung", sub: "für präzise und effiziente Arbeit" },
  { title: "Zuverlässig & termintreu", sub: "auf die Minute genau" },
  { title: "Faire & transparente Preise", sub: "ohne versteckte Kosten" },
  { title: "Präzise Arbeit", sub: "nach höchsten deutschen Standards" },
];

export const TRUST = [
  { icon: "Headset", l1: "Kostenlose", l2: "Beratung" },
  { icon: "Euro", l1: "Faire", l2: "Preise" },
  { icon: "ShieldCheck", l1: "Sauber & Zuverlässig", l2: "von Anfang bis Ende" },
  { icon: "Zap", l1: "Flexibel &", l2: "Schnell" },
  { icon: "UsersRound", l1: "Zufriedene", l2: "Kunden" },
];

export const GALLERY = [
  { url: "/work-kernbohrung.webp", title: "Kernbohrung", span: "lg:col-span-2 lg:row-span-2" },
  { url: "/work-schlitz.webp", title: "Schlitzarbeiten", span: "" },
  { url: "/work-leerrohre.webp", title: "Leerrohre & Kabelzug", span: "" },
  { url: "/hero-worker.webp", title: "Im Einsatz", span: "" },
  { url: "/work-dosen.webp", title: "Dosenbohrungen", span: "" },
  { url: "/work-van.jpg", title: "Unser Team vor Ort", span: "lg:col-span-2" },
  { url: "/work-stair.webp", title: "Elektrovorbereitung", span: "" },
];

export const REF_THUMBS = [
  "/work-schlitz.webp",
  "/work-leerrohre.webp",
  "/work-dosen.webp",
];

export const HOURS = [
  { day: "Montag – Freitag", time: "07:00 – 18:00" },
  { day: "Samstag", time: "08:00 – 14:00" },
  { day: "Sonntag", time: "Geschlossen" },
];

export const WHY_FEATURES = [
  { icon: "Crosshair", title: "Präzise Ausführung", desc: "Millimetergenaue Kernbohrungen und Schlitze nach höchsten Standards." },
  { icon: "Sparkles", title: "Saubere Baustellen", desc: "Staubarmes Arbeiten mit moderner Absaugtechnik – wir hinterlassen alles sauber." },
  { icon: "CalendarCheck", title: "Termintreue", desc: "Zuverlässige Terminplanung und pünktliche Fertigstellung Ihrer Projekte." },
  { icon: "BadgeEuro", title: "Faire Preise", desc: "Transparente Angebote ohne versteckte Kosten – kostenlos und unverbindlich." },
  { icon: "Shuffle", title: "Flexible Einsätze", desc: "Kurzfristige Termine und flexible Einsätze in ganz Bayern und der Region Nürnberg." },
  { icon: "Wrench", title: "Professionelles Equipment", desc: "Wir arbeiten ausschließlich mit hochwertigem Profi-Werkzeug führender Marken." },
];

export const REVIEWS = [
  { name: "Thomas Berger", role: "Elektromeister, Nürnberg", rating: 5, text: "Absolut präzise Kernbohrungen und top Termintreue. Die Zusammenarbeit war professionell und die Baustelle blieb dank guter Absaugung sauber. Jederzeit wieder!" },
  { name: "Sandra Klein", role: "Bauleiterin, Fürth", rating: 5, text: "Sehr saubere und staubarme Arbeitsweise. VoltCore hat unsere Elektrovorbereitung schnell und zuverlässig umgesetzt. Klare Empfehlung für jedes Bauprojekt." },
  { name: "Michael Hofmann", role: "Elektroinstallateur, Erlangen", rating: 5, text: "Faire Preise, professionelles Equipment und ein eingespieltes Team. Schlitzarbeiten und Dosenbohrungen wurden exakt nach Plan ausgeführt. Top Qualität!" },
  { name: "Andreas Wagner", role: "Bauunternehmer, Bayern", rating: 5, text: "Kurzfristige Terminvergabe und flexible Einsätze – genau das, was wir gebraucht haben. Der Kabelzug und die Leerrohre sitzen perfekt. Sehr empfehlenswert." },
];
